//@ts-check
let requestId = 0;

const generateSimpleId = () => {
  const now = Date.now().toString(); 
  const rand = Math.floor(Math.random() * 100).toString().padStart(2, '0'); // 00〜99
  return Number(now + rand); 
};
export default class WindowController {
  constructor(listeners = {}, masterDidChange = null, prefix) {
    this.id = generateSimpleId();
    this.isMaster = false;
    this.others = {};
    this.BROADCAST = `${prefix}_broadcast`;
    window.addEventListener('storage', this, false);
    window.addEventListener('unload', this, false);

    this._masterDidChange = masterDidChange || (() => { });

    const privateListeners = {
      hello: event => {
        this.others[event.id] = Date.now();
        if (this.id <= event.id) {
          this.sendPing();
        }
      },

      ping: event => {
        this.others[event.id] = Date.now();
      },

      bye: event => {
        delete this.others[event.id];
        this.check();
      }
    };

    this.listeners = {
      ...listeners,
      ...privateListeners
    };

    this.broadcast('hello');

    const check = () => {
      this.check();
      this._checkTimeout = setTimeout(check, 9000);
    };

    const ping = () => {
      this.sendPing();
      this._pingTimeout = setTimeout(ping, 17000);
    };

    this._checkTimeout = setTimeout(check, 500);
    this._pingTimeout = setTimeout(ping, 17000);
  }

  destroy() {
    clearTimeout(this._pingTimeout);
    clearTimeout(this._checkTimeout);

    window.removeEventListener('storage', this, false);
    window.removeEventListener('unload', this, false);

    this.broadcast('bye');
  }

  handleEvent(event) {
    if (event.type === 'unload') {
      this.destroy();
    } else if (event.key === this.BROADCAST) {
      try {
        const data = JSON.parse(event.newValue);
        if (data.id !== this.id) {
          this.listeners[data.type](data);
        }
        // eslint-disable-next-line no-empty
      } catch (error) { }
    }
  }

  sendPing() {
    this.broadcast('ping');
  }

  check() {
    const now = Date.now();
    let takeMaster = true;
    for (const id in this.others) {
      // 前回のpingから2分以上経過していたら
      // そのタブは消されたと見なし、取り除く
      if (this.others[id] + (2 * 60 * 1000) < now) {
        delete this.others[id];
      }
      if (Number(id) < this.id) {
        takeMaster = false;
      }
    }
    this.isMaster = takeMaster;
    this._masterDidChange();
  }

  broadcast(type, data) {
    const event = {
      id: this.id,
      reqId: ++requestId,
      type,
      data
    };
    try {
      localStorage.setItem(this.BROADCAST, JSON.stringify(event));
      setTimeout(() => {
        localStorage.removeItem(this.BROADCAST);
      }, 3000);
      // eslint-disable-next-line no-empty
    } catch (error) { }
    return event;
  }
}


class LockedWindowController {
  constructor(listeners = {}, masterDidChange, prefix) {
    this.isMaster = false;
    const lockName = `${prefix}-fcit2-worker-lock`;
    const tryRequestLock = async () => {
      await navigator.locks.request(
        lockName,
        { mode: 'exclusive', ifAvailable: true },
        async (lock) => {
          if (lock) {
            this.isMaster = true;
            masterDidChange();
            await new Promise(() => { });
          } else {
            if (!this.isMaster) {
              masterDidChange();
            }
          }
        }
      );
    };
    tryRequestLock();
    setInterval(() => {
      tryRequestLock();
    }, 3000);
  }
}